import XEndpoints from "../../core/config/Endpoints";
import XApi from "../../utils/Api";

export class SaleService {
  // Sale
  async addSale(data: any) {
    const token = localStorage.getItem("token");
    if (token) {
      const response = await XApi.post(XEndpoints.sale, data, {
        "Content-Type": "application/json",
        Authorization: token,
      });
      return response ?? null;
    }
    return null;
  }

  async updateSale(id: number, data: any) {
    const token = localStorage.getItem("token");
    if (token) {
      const response = await XApi.patch(
        `${XEndpoints.sale}/detail/${id}`,
        data,
        {
          "Content-Type": "application/json",
          Authorization: token,
        }
      );
      return response ?? null;
    }
    return null;
  }

  async getSale(id: number) {
    const token = localStorage.getItem("token");
    if (token) {
      const response = await XApi.get(`${XEndpoints.sale}/detail/${id}`, {
        "Content-Type": "application/json",
        Authorization: token,
      });
      return response ?? null;
    }
    return null;
  }

  async exportSale(data: any) {
    const token = localStorage.getItem("token");
    if (token) {
      const response = await XApi.post(`${XEndpoints.sale}/export`, data, {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      });
      return response ?? null;
    }
    return null;
  }

  // Credit Note
  async addCreditNote(data: any) {
    const token = localStorage.getItem("token");
    if (token) {
      const response = await XApi.post(XEndpoints.creditNote, data, {
        "Content-Type": "application/json",
        Authorization: token,
      });
      return response ?? null;
    }
    return null;
  }

  async updateCreditNote(id: number, data: any) {
    const token = localStorage.getItem("token");
    if (token) {
      const response = await XApi.patch(
        `${XEndpoints.creditNote}/detail/${id}`,
        data,
        {
          "Content-Type": "application/json",
          Authorization: token,
        }
      );
      return response ?? null;
    }
    return null;
  }

  async getCreditNote(id: number) {
    const token = localStorage.getItem("token");
    if (token) {
      const response = await XApi.get(`${XEndpoints.creditNote}/detail/${id}`, {
        "Content-Type": "application/json",
        Authorization: token,
      });
      return response ?? null;
    }
    return null;
  }

  async exportCreditNote(data: any) {
    const token = localStorage.getItem("token");
    if (token) {
      const response = await XApi.post(
        `${XEndpoints.creditNote}/export`,
        data,
        {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      );
      return response ?? null;
    }
    return null;
  }
}
